import React, { Component } from 'react';
import { shape, string, bool, arrayOf } from 'prop-types';
import { gql, graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import { last } from 'lodash';

import locationShape from 'propTypes/locationShape';
import coord from 'propTypes/coord';

import { operations as routeCreationOperations } from 'state/ducks/routeCreation';
import { operations as mapOperations } from 'state/ducks/map';

import LoadingIndicator from 'components/LoadingIndicator';

import LocationMarkerGroup from './LocationMarkerGroup';
import SegmentGroup from './SegmentGroup';

import styles from './CreateRoute.scss';

const CreateRouteMapQuery = gql`
  query CreateRouteMap {
    locations {
      id
      lat
      lng
      name
      trackingDevice {
        id
        name
        status
        batteryVoltage
        temperature
        reportInterval
        lastUpdate
        numberOfHitsToday
      }
    }
    segments {
      id
      status
      path
      bounds
      liveTravelTime
      expectedTravelTime
      from {
        id
        name
      }
      to {
        id
        name
      }
    }
  }
`;

class CreateRouteMap extends Component {
  componentWillUpdate(nextProps) {
    const { data: { locations }, setAllFeatureBounds } = nextProps;

    /* only update bounds on first data render */
    if (this.props.data.loading && !nextProps.loading) {
      const bounds = locations.reduce((acc, v) => [...acc, [v.lat, v.lng]], []);
      setAllFeatureBounds(bounds);
    }
  }

  render() {
    const {
      params,
      data: { loading, locations, segments },
      selectedSegments,
      createdRouteId,
    } = this.props;

    if (loading) {
      return <LoadingIndicator />;
    }

    const isFlowFinished = Boolean(createdRouteId);

    const availableOrSelectedSegments = segments.reduce((acc, segment) => {
      // if nothing is selected, all segmenets should be available
      if (selectedSegments.length === 0) {
        return [...acc, { isAvailable: true, ...segment }];
      }

      if (selectedSegments.includes(segment.id)) {
        return [...acc, { isSelected: true, ...segment }];
      }

      const lastSelectedSegment = segments.find(seg => seg.id === last(selectedSegments));

      if (lastSelectedSegment && lastSelectedSegment.to.id === segment.from.id) {
        return [...acc, { isAvailable: true, ...segment }];
      }

      return acc;
    }, []);

    return (
      <div className={styles.main}>
        <LocationMarkerGroup
          locations={locations}
          segments={segments}
          selectedSegments={selectedSegments}
          routeParams={params}
        />
        <SegmentGroup
          segments={
            availableOrSelectedSegments.length === 0 ? segments : availableOrSelectedSegments
          }
          lastSelectedSegment={last(selectedSegments)}
          disableInteraction={isFlowFinished}
        />
      </div>
    );
  }
}

CreateRouteMap.propTypes = {
  data: shape({
    loading: bool.isRequired,
    locations: arrayOf(locationShape),
    segments: arrayOf(
      shape({
        id: string,
        path: arrayOf(coord),
        from: locationShape,
        to: locationShape,
      })
    ),
  }).isRequired,
  selectedSegments: arrayOf(string).isRequired,
  params: shape({}),
  createdRouteId: string,
};

const mapStateToProps = ({ map, routeCreation }) => ({
  viewMode: map.viewMode,
  selectedSegments: routeCreation.selectedSegments,
  createdRouteId: routeCreation.createdRouteId,
});

const ConnectedCreateRouteMapWithData = compose(
  connect(mapStateToProps, { ...mapOperations, ...routeCreationOperations }),
  graphql(CreateRouteMapQuery, {})
)(CreateRouteMap);

export default ConnectedCreateRouteMapWithData;



// WEBPACK FOOTER //
// ./src/components/Map/CreateRoute/index.js